import MerchantGiftCardBalance from '@/components/public/merchantGiftCard/balance';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

const MerchantGiftCardBalancePage = (): JSX.Element => {
    const { merchantId } = useParams<{ merchantId: string }>();

    return (
        <Box
            sx={{
                minHeight: 'calc(100vh - 200px)',
                display: 'flex',
                justifyContent: 'center',
                py: { xs: 3, sm: 5 }
            }}
        >
            <MerchantGiftCardBalance merchantId={merchantId} />
        </Box>
    );
};

export default MerchantGiftCardBalancePage;
